import { AppProvider } from 'src/providers/app';
import { AppRoutes } from 'src/routes';

// We wrap the app in a provider function with helper wrappers (error handling, react query, etc.)
// We then pass the app routes which consist of public and protected routes as children
function App() {
    return (
        <AppProvider>
            <AppRoutes />
        </AppProvider>
    );
}

export default App;
